
import {useFiltrate} from '@/hooks/index'
import { useRoute } from 'vue-router'
export default {
  props:{
    transferData:{
      type:Array, default:()=>{
      return []
    }
    }, 
    radioCheck:{
        type:Boolean,
        default:false
    },
    headline:{
      type:String
    },
      categoryList:{
           type:Function,
          default:()=>{

          }
        }
  },
   setup(props: Object,cxt: any){
      let route = useRoute();
      let active = -1
      switch(route.query.logistic_type){
         case '1' :
           active = 0
           break;
         case '2' :
           active = 1
           break;
         case '0' :
           active = 2
      }
    let attr:any = [route.query.free_shipping ? 0:'',route.query.have_gift ? 1:'',]
    const {categoryClick,serviceActive,check_goods_exit,unwindList,remove_clones,multiple_clones} =   useFiltrate(props,cxt,attr,active)
    let clone_class = ()=>{
      multiple_clones()
       // @ts-ignore
        document.querySelectorAll('.setRefDemo').forEach((e:any) => {
            e.classList.remove('brandActie')
        });
    }
          return {
           categoryClick,
           serviceActive,
           unwindList,
           check_goods_exit,
           remove_clones,
           clone_class
          }
   }
}
